import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

/**
 * An on/off card: title, optional description, optional logo, a check when selected, and the
 * tooltip on the whole card. The parent owns the state — it passes `selected` in and reacts to
 * `toggled`.
 */
@Component({
  selector: 'ui-selectable-tile',
  imports: [MatIcon, MatTooltip],
  templateUrl: './selectable-tile.component.html',
  styleUrl: './selectable-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectableTileComponent {
  title = input.required<string>();
  description = input<string | null | undefined>(null);
  logoUrl = input<string | null | undefined>(null);
  tooltip = input<string | null | undefined>(null);
  selected = input(false);

  toggled = output<void>();
}
